module.exports = __webpack_public_path__ + "img/Is_the_information.696ecf3c.png";